



const MESSAGES = {
  CODE_INVALID: 'Please provide a valid token',
  TOKEN_INVALID: 'Please provide a valid token',
  TOKEN_NOT_FOUND: 'That token doesn\'t exist or has expired. Please login again.',
  UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
} as {
  [key: string]: string;
};

export default {
  created() {
    const { token } = this.$route.query;
    token
      ? this.$store
        .dispatch('auth/login', { tokenId: token })
        .then(
          () => this.$router.push({ name: 'dashboard' }),
          (e: any) => {
            const content = MESSAGES[e.code] || MESSAGES.UNKNOWN_ERROR;
            this.$store.commit('dialog/CREATE', {
              title: 'Error',
              compact: true,
              content,
              buttons: [{
                text: 'Login',
                click: (dialog: any) => {
                  dialog.close();
                  this.$router.push({ name: 'home' });
                },
              }],
            });
          })
      : this.$router.push({
          name: 'home',
        });
  },
} as IView;
